import find from 'lodash/find';

const getProductOptionsFromState = (state) => state.productOptions;
export const getProductOptionById = (state, optionId) => find(getProductOptionsFromState(state), ({id}) => id === optionId) || null;
export const getProductOptionsByIds = (state, optionIds) => getProductOptionsFromState(state).filter(({id}) => optionIds.indexOf(id) !== -1);

export const getProductOptionIds = (state) => getProductOptionsFromState(state).map(({id}) => id);